import * as actions from "./actionType";
import { ReduxActionType } from "#/types/ActionType";

type HeaderType = {
  headerWidth: number;
  headerHeight: number;
};

interface AppType extends HeaderType {
  appWidth: number;
  appHeight: number;
}

function getHeaderSize() {
  const header: HTMLElement | null = document.querySelector<HTMLElement>(".header");
  const headerWidth = header ? header.offsetWidth : 0;
  const headerHeight = header ? header.offsetHeight : 0;
  return {
    headerWidth,
    headerHeight,
  };
}

export const infraResize = (): ReduxActionType<AppType> => {
  const appWidth = global.innerWidth > 0 ? global.innerWidth : window.screen.width;
  const appHeight = global.innerHeight > 0 ? global.innerHeight : window.screen.height;

  return {
    type: actions.INFRA_RESIZE,
    data: {
      appWidth,
      appHeight,
      ...getHeaderSize(),
    },
  };
};

export const infraSetHeaderSize = (): ReduxActionType<HeaderType> => ({
  type: actions.INFRA_SET_HEADER_SIZE,
  data: { ...getHeaderSize() },
});

export const cleanAxoisResultData = (): ReduxActionType<null> => ({
  type: actions.CLEAN_AXIOS_RESULT,
  data: null,
});

export const fetchServiceTokens = (token: string): ReduxActionType<string> => ({
  type: actions.FETCH_SERVICE_TOKENS,
  data: token,
});

export type FetchStatisticsPayload = {
  token: string;
  serviceTokenId?: string;
  range?: "7d" | "14d" | "30d";
};

export const fetchStatistics = (
  payload: FetchStatisticsPayload,
): ReduxActionType<FetchStatisticsPayload> => ({
  type: actions.FETCH_STATISTICS,
  data: payload,
});
